import React from "react";

import SearchableDropdownComponent from "@common/components/shared/forms/SearchableDropdownComponent";
import OfficerFormModalAction from "@common/redux/actions/OfficerFormModalAction";
import TableComponent from "@common/components/shared/forms/TableComponent";
import InputComponent from "@common/components/shared/forms/InputComponent";
import useOfficerForm from "../../hooks/useOfficerForm";
import { transformOfficerData } from "../../helpers/tables";

const OfficerForm = ({ handleNewOfficer, handleRemoveOfficer }) => {
  const {
    methods,
    loadingOfficers,
    officer,
    officersOptions,
    officerTypeId,
    additionButton,
    handleAddition,
    handleSearch,
    onSelect,
  } = useOfficerForm({ handleNewOfficer });
  const {
    control,
    register,
    formState: { errors },
  } = methods;

  return (
    <>
      <SearchableDropdownComponent
        name="searchedOfficer"
        label="Search Officer (Name or Badge Number)"
        placeholder="Search for an officer..."
        control={control}
        error={errors.searchedCustomer}
        options={officersOptions}
        loading={loadingOfficers}
        allowAdditions={true}
        additionButton={additionButton}
        handleAddition={handleAddition}
        handleSearch={handleSearch}
        handleFocus={() => handleSearch("")}
        onType={OfficerFormModalAction.onType}
        noResultsMessage="No results found"
        onSelect={onSelect}
      />
      {officer && (
        <TableComponent
          rows={[transformOfficerData(officer)]}
          handleRemove={handleRemoveOfficer}
          nameColumnClassName="w-30"
          secondColumnName="Details"
        />
      )}
      {(officerTypeId === 1 || !officerTypeId) && (
        <InputComponent
          name="incidentNumber"
          label="Incident Number"
          placeholder="Enter incident number..."
          register={register}
          error={errors.incidentNumber}
        />
      )}
    </>
  );
};

export default OfficerForm;
